import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { Layout } from './components/Layout/Layout';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import PublicRoute from './components/Auth/PublicRoute';

// Pages
import { LoginPage } from './pages/Auth/LoginPage';
import { DashboardPage } from './pages/Dashboard/DashboardPage';
import { QueuesPage } from './pages/Queues/QueuesPage';
import { QueueDetailPage } from './pages/Queues/QueueDetailPage';
import { TicketsPage } from './pages/Tickets/TicketsPage';
import { OperatorsPage } from './pages/Operators/OperatorsPage';
import { ServicesPage } from './pages/Services/ServicesPage';
import WorkstationsPage from './pages/Workstations/WorkstationsPage';
import { AnalyticsPage } from './pages/Analytics/AnalyticsPage';
import ReportsPage from './pages/Reports/ReportsPage';
import SettingsPage from './pages/Settings/SettingsPage';
import QueueSettingsPage from './pages/QueueSettings/QueueSettingsPage';
import QueuePatternsPage from './pages/QueueSettings/QueuePatternsPage';
import { UsersPage } from './pages/Users/UsersPage';
import OrganizationsPage from './pages/SuperAdmin/OrganizationsPage';
import { OperatorPage } from './pages/Operator/OperatorPage';
import { NotFoundPage } from './pages/NotFound/NotFoundPage';

// Routing only; providers and global CSS are configured in index.tsx

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <Routes>
        {/* Публичные роуты (только для неавторизованных) */}
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          } 
        />

        {/* Защищенные роуты (только для авторизованных) */}
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="queues" element={<QueuesPage />} />
          <Route path="queues/:id" element={<QueueDetailPage />} />
          <Route path="tickets" element={<TicketsPage />} />
          <Route path="operators" element={<OperatorsPage />} />
          <Route path="workstations" element={<WorkstationsPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="settings/queues" element={<QueueSettingsPage />} />
          <Route path="settings/queue-patterns" element={<QueuePatternsPage />} />
          <Route path="users" element={<UsersPage />} />
          
          {/* Роут для операторов */}
          <Route 
            path="operator" 
            element={
              <ProtectedRoute requiredRoles={['operator']}>
                <OperatorPage />
              </ProtectedRoute>
            } 
          />
          
          {/* Роут только для супер-админа */}
          <Route 
            path="super-admin/organizations" 
            element={
              <ProtectedRoute requiredRoles={['super_admin']}>
                <OrganizationsPage />
              </ProtectedRoute>
            } 
          />
          
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
};

export default App;